import Banner from "./banner";
import Card from "./card";
import Categories from "./categories";
import Footer from "./footer";
import Menu from "./menu";
import Navbar from "./navbar";
import Recomendations from "./recomendations";
import Stocks from "./stocks";
import Title from "./title";

export const Components = {
  Navbar,
  Banner,
  Title,
  Recomendations,
  Card,
  Menu,   
  Categories,
  Stocks,
  Footer
}